<template>
  <div v-show="isShow" class="popup_wrap">
    <div class="popup_box">
      <div class="popup_text_box">
        <div class="title" v-html="$tc('timeoutpopup_01_text_01')"></div>
        <div class="text" v-html="$tc('timeoutpopup_02_text_02', this.timer)"></div>
      </div>
      <div class="btn_wrap">
        <button @click="moveToHome" class="go-home">{{ $tc('timeoutpopup_03_goHome') }}</button>
        <button @click="close" class="continue">{{ $tc("timeoutpopup_04_continue") }}</button>
      </div>
    </div>
    <!-- <div class="popup">
      <div class="contnets">
        <img src="@/assets/img/clock.svg" />
        <div class="text first" :class="{ isEng: locale === 'en' }" v-html="$tc('timeoutpopup_01_text_01')"></div>
        <div class="text" v-html="$tc('timeoutpopup_02_text_02', this.timer)"></div>
      </div>
      <div class="button_wrap">
        <div class="button go-home" @click="moveToHome">{{ $tc('timeoutpopup_03_goHome') }}</div>
        <div class="button continue" @click="close">{{ $tc('timeoutpopup_04_continue') }}</div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'timeout-popup',
  props: {
    isShow: { type: Boolean }
  },
  computed: {
    ...mapState(['locale'])
  },
  watch: {
    isShow (val) {
      if (val) {
        this.timer = 10
        this.intervalObj = setInterval(() => {
          this.timer--
          if (this.timer === 0) {
            this.moveToHome()
          }
        }, 1000)
      }
    }
  },
  data () {
    return {
      intervalObj: null,
      timer: 10
    }
  },
  methods: {
    close () {
      clearInterval(this.intervalObj)
      this.$emit('close')
    },
    moveToHome () {
      clearInterval(this.intervalObj)
      // this.$router.push('/')
      this.$emit('moveToHome')
    }
  },
  destroyed () {
    clearInterval(this.intervalObj)
    // console.debug('timeout-popup destroyed---', this.intervalObj)
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/base.scss";

.popup_wrap {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
}

.popup_box {
  display: flex;
  width: 66.40625vw;
  padding: 7.5vh 3.90625vw 6.25vh;
  flex-direction: column;
  @include flex-gap(5vh, column);
  border-radius: 4vh;
  border: 1px solid $e0;
  background: $white;
}

.popup_text_box {
  display: flex;
  flex-direction: column;
  @include flex-gap(3.5vh, column);
  .title {
    color: $black;
    text-align: center;
    font-size: 36px; // IE11 fallback
    font-size: unquote("min(2.8125vw, 36px)");
    font-weight: 700;
    line-height: 6.63vh;
  }
  .text {
    color: #2E3137;
    text-align: center;
    font-size: 30px; // IE11 fallback
    font-size: unquote("min(2.34375vw, 30px)");
    font-weight: 500;
    line-height: 5.5vh;
  }
}

.btn_wrap {
  display: flex;
  @include flex-gap(2.5vh, row);
  button {
    width: 100%;
    height: 11.75vh;
    padding: 3.25vh 0.78125vw;
    justify-content: center;
    align-items: center;
    border-radius: 2.5vh;
    background: #E6E8EB;
    color: #2E3137;
    font-size: 32px; // IE11 fallback
    font-size: unquote("min(2.5vw, 32px)");
    font-weight: 700;
    line-height: 4.75vh;
  }
  .continue {
    background: #D81B1B;
    color: $white;
  }
}
/* .popup_wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 1280px;
  height: 800px;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  .popup {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 72px 72px 36px;
    background: $white;
    border-radius: 32px;
    border: 1px solid $e0;
    box-shadow: 0px 4px 8px 0px rgba(19, 21, 23, 0.30);
    .contnets {
      width: 816px;
      text-align: center;
      img {
        margin: 0 0 24px 0;
      }
      .text {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $gray_700;
        font-size: 32px;
        line-height: 1.5;
        &.first {
          margin: 0 0 16px 0;
          color: $gray_900;
        }
        &.isEng {
          display: block;
        }
      }
    }
    .button_wrap {
      display: flex;
      @include flex-gap(16px, row);
      padding: 72px 0 0 0;
      .button {
        min-width: 219px;
        padding: 16px 22px;
        border-radius: 16px;
        border: 2px solid $gray_900;
        background: $white;
        font-size: 24px;
        color: $gray_900;
        line-height: 1.5;
        text-align: center;
        cursor: pointer;
        &.continue {
          width: 100%;
          padding: 18px 24px;
          background: $light_blue;
          color: $white;
          border: none;
          font-weight: 600;
        }
      }
    }
  }
} */
</style>
